export default class CookieHelper {
  static getCookie(name) {
    name = name + "=";
    // #282: split the RAW cookie string on ";" first, then decode each value.
    // The previous order (decodeURIComponent the whole string, then split)
    // corrupted any value whose encoded form contained "%3B"/"%2C" etc. -- the
    // decode turned them back into ";"/"," and the split then truncated the
    // value, so JSON.parse blew up.
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return decodeURIComponent(c.substring(name.length, c.length));
      }
    }
    return false;
  }

  static setCookie(name, value) {
    const localhost = process.env.REACT_APP_API.includes("localhost");
    // #282: a same-name cookie written in a DIFFERENT variant is a distinct
    // cookie, so the new write stacks a second copy instead of overwriting and
    // getCookie reads back whichever the browser lists first. That is what made
    // a just-added account disappear: a stale pre-CHIPS (non-partitioned)
    // cur_accounts coexisted with the fresh partitioned one. The current code
    // only ever writes the partitioned variant, so any non-partitioned (or
    // parent-domain) copy is always legacy/stale -- expire those first so
    // exactly one cookie survives each write (existing browsers self-heal on
    // their next login/add/swap).
    if (!localhost) {
      const epoch = new Date(0).toUTCString();
      const expire = name + "=;path=/;expires=" + epoch + ";";
      document.cookie = expire + "samesite=none;secure=true"; // legacy non-partitioned, host-only
      document.cookie = expire + "samesite=none;secure=true;domain=.digadop.com"; // defensive: any parent-domain copy
    }
    //Set expiration to 7 days
    let now = new Date();
    now.setDate(now.getDate() + 7);
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      ";expires=" +
      now.toUTCString() +
      ";path=/;" +
      // Partitioned (CHIPS) keeps the cookie usable when the app runs inside
      // the Salesforce LWC iframe with third-party cookies blocked (Incognito,
      // Chrome third-party-cookie phaseout): the cookie lives in a
      // per-embedder partition instead of being rejected (#91).
      (localhost ? "" : "samesite=none;secure=true;partitioned");
  }

  static deleteCookie(name) {
    let now = new Date();
    // expire BOTH variants: a partitioned cookie is only matched by a
    // partitioned write, while cookies set before the CHIPS change (or on
    // localhost) are unpartitioned
    let base = name + "=;path=/;expires=" + now.toUTCString() + ";";
    document.cookie = base;
    if (!process.env.REACT_APP_API.includes("localhost")) {
      // legacy pre-CHIPS cookies (SameSite=None, unpartitioned); this form is
      // also the only delete that works from inside the LWC iframe
      document.cookie = base + "samesite=none;secure=true";
      document.cookie = base + "samesite=none;secure=true;partitioned";
    }
  }
}
